/* tslint:disable */
/* eslint-disable */
/**
 * RoadFootage.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { AddressDtoFromJSON, AddressDtoToJSON, } from './AddressDto';
import { CrashDateTimePrecisionFromJSON, CrashDateTimePrecisionToJSON, } from './CrashDateTimePrecision';
import { CrashSeverityLevelFromJSON, CrashSeverityLevelToJSON, } from './CrashSeverityLevel';
import { CrashTypeCategoryFromJSON, CrashTypeCategoryToJSON, } from './CrashTypeCategory';
import { OpenDataSourceFromJSON, OpenDataSourceToJSON, } from './OpenDataSource';
/**
 * Check if a given object implements the RecordedCrashDto interface.
 */
export function instanceOfRecordedCrashDto(value) {
    let isInstance = true;
    return isInstance;
}
export function RecordedCrashDtoFromJSON(json) {
    return RecordedCrashDtoFromJSONTyped(json, false);
}
export function RecordedCrashDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'kind': !exists(json, 'kind') ? undefined : json['kind'],
        'source': !exists(json, 'source') ? undefined : OpenDataSourceFromJSON(json['source']),
        'crashDateTime': !exists(json, 'crashDateTime') ? undefined : (new Date(json['crashDateTime'])),
        'crashTimezone': !exists(json, 'crashTimezone') ? undefined : json['crashTimezone'],
        'dateTimePrecision': !exists(json, 'dateTimePrecision') ? undefined : CrashDateTimePrecisionFromJSON(json['dateTimePrecision']),
        'severity': !exists(json, 'severity') ? undefined : CrashSeverityLevelFromJSON(json['severity']),
        'fatalityCount': !exists(json, 'fatalityCount') ? undefined : json['fatalityCount'],
        'injuryCount': !exists(json, 'injuryCount') ? undefined : json['injuryCount'],
        'crashType': !exists(json, 'crashType') ? undefined : CrashTypeCategoryFromJSON(json['crashType']),
        'address': !exists(json, 'address') ? undefined : AddressDtoFromJSON(json['address']),
        'latitude': !exists(json, 'latitude') ? undefined : json['latitude'],
        'longitude': !exists(json, 'longitude') ? undefined : json['longitude'],
        'distanceMeters': !exists(json, 'distanceMeters') ? undefined : json['distanceMeters'],
        'hasFootage': !exists(json, 'hasFootage') ? undefined : json['hasFootage'],
        'footageCount': !exists(json, 'footageCount') ? undefined : json['footageCount'],
    };
}
export function RecordedCrashDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'kind': value.kind,
        'source': OpenDataSourceToJSON(value.source),
        'crashDateTime': value.crashDateTime === undefined ? undefined : (value.crashDateTime.toISOString()),
        'crashTimezone': value.crashTimezone,
        'dateTimePrecision': CrashDateTimePrecisionToJSON(value.dateTimePrecision),
        'severity': CrashSeverityLevelToJSON(value.severity),
        'fatalityCount': value.fatalityCount,
        'injuryCount': value.injuryCount,
        'crashType': CrashTypeCategoryToJSON(value.crashType),
        'address': AddressDtoToJSON(value.address),
        'latitude': value.latitude,
        'longitude': value.longitude,
        'distanceMeters': value.distanceMeters,
        'hasFootage': value.hasFootage,
        'footageCount': value.footageCount,
    };
}
